/* Remove only legacy promotion-tagged lines; paid/manual accessories remain untouched. */
(function () {
  if (window.CasameRetiredGiftCleanup) return;
  var originalFetch = window.fetch.bind(window), pending = null, bypass = false;
  var base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  function updatesFor(cart) {
    var updates = {};
    (cart.items || []).forEach(function (line) {
      if (line.properties && line.properties._auto_gift === 'threshold') updates[line.key] = 0;
    });
    return updates;
  }
  function clean() {
    if (pending) return pending;
    pending = originalFetch(base + 'cart.js', {headers: {'Accept': 'application/json'}})
      .then(function (r) { if (!r.ok) throw Error('Cart unavailable'); return r.json(); })
      .then(function (cart) {
        var updates = updatesFor(cart);
        if (!Object.keys(updates).length) return;
        return originalFetch(base + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({updates: updates})})
          .then(function (r) { if (!r.ok) throw Error('Gift removal failed'); return r.json(); })
          .then(function (cart) {
            if (Object.keys(updatesFor(cart)).length) throw Error('Gift still present');
            document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
            if (/\/cart\/?$/.test(location.pathname)) location.reload();
          });
      }).finally(function () { pending = null; });
    return pending;
  }
  function quietlyClean() { clean().catch(function () { /* Checkout retries and reports failure. */ }); }
  window.CasameRetiredGiftCleanup = {clean: clean, updatesFor: updatesFor};
  window.fetch = function () {
    var url = String(arguments[0] && arguments[0].url || arguments[0] || '');
    var result = originalFetch.apply(null, arguments);
    if (/\/cart\/(add|change|update|clear)(?:\.js|\?|$)/.test(url)) result.then(quietlyClean).catch(function () {});
    return result;
  };
  document.addEventListener('cart:refresh', quietlyClean);
  document.addEventListener('click', function (event) {
    var target = event.target.closest('[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]');
    if (!target || bypass) return;
    event.preventDefault(); event.stopImmediatePropagation();
    clean().then(function () { bypass = true; target.click(); bypass = false; })
      .catch(function () { alert('Please refresh your basket before checking out. We could not remove a retired promotional gift.'); });
  }, true);
  document.addEventListener('submit', function (event) {
    if (bypass || !event.submitter || event.submitter.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    var form = event.target, submitter = event.submitter;
    clean().then(function () { bypass = true; form.requestSubmit(submitter); bypass = false; })
      .catch(function () { alert('Please refresh your basket before checking out. We could not remove a retired promotional gift.'); });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', quietlyClean); else quietlyClean();
})();
